'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";

class pageProgressProvider
{
	state = false;
	constructor(){
		
	}
	
	start(){
		this.state = true;
	}
	
	stop(){
		this.state = false;
	}
	
	getState(){
		return this.state;
	}
	
	setHttp(httpProvider){
		this.start();
		httpProvider.then(() => this.stop(), () => this.stop());
	}
}

EwSiteApp.factory('pageProgress', function(){
	return new pageProgressProvider();
});